export interface BroadcastPayload{
    key:string,
    payload?:Record<string, any>
}
export const useBroadcast=()=>{
    const channel = new BroadcastChannel("office-addin-channel");
    
    const sendMessage=(param:BroadcastPayload)=>{
        channel.postMessage({
            type: param.key, at: Date.now(), payload:param?.payload!
        });
        channel.close();
    }
    
    return {sendMessage, channel}
}